export default __webpack_public_path__ + "static/media/deepLearningAI.a72123e9.png";